export class Maybe<T> {
    private constructor(public value: T | null = null) {}

    static nothing<T>(): Maybe<T> {
        return new Maybe<T>(null);
    }
    static just<T>(value: T): Maybe<T> {
        return new Maybe<T>(value);
    }

    static justIf<T>(condition: boolean, value: T | (() => T)): Maybe<T> {
        if (condition) {
            return value instanceof Function ? Maybe.just<T>(value()) : Maybe.just<T>(value);
        }

        return Maybe.nothing<T>();
    }

    getOrDefault(defaultValue: T): T {
        return this.value ?? defaultValue;
    }

    ifElse<ReturnType>(withValue: (value: T) => ReturnType, noValue: () => ReturnType): ReturnType {
        return this.value === null ? noValue() : withValue(this.value);
    }

    ifEmpty<ReturnType>(nonEmpty: (value: T) => ReturnType, empty: () => ReturnType): ReturnType {
        if (typeof this.value === "string") {
            return this.value === "" ? empty() : nonEmpty(this.value);
        }

        return this.ifElse(nonEmpty, empty);
    }
}
